import React from "react";

/*
 * props:
 * options: [...]
 * selected: ...
 * onSelect: (option) => (...)
 */
export default function ({selected, options, onSelect, style, isReadOnly}) {
    const btnClass = "btn btn-default btn-transparent text-outline";
    const fallback = isReadOnly ? " disabled" : "";
    let getBtnClass = (option) => btnClass + (option===selected ? " active" : fallback);

    const buttons = options.map((option) => (
        <a key={option} onClick={() => onSelect(option)} className={getBtnClass(option)}>
            {option}
        </a>
    ));

    return (
        <div style={style} className="btn-group btn-group-lg btn-group-justified">
            {buttons}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/js/ButtonSelectionGroup.js